"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
var _consts = require("../../utils/styles/consts");
var _InlineLoader = require("../../utils/components/InlineLoader");
var _styledComponents = require("styled-components");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/**
 * Wraps the field and provides a label for it.
 */
const FieldWrapper = _ref => {
  let {
    label,
    errorMessage,
    required = false,
    style,
    children,
    loading,
    loaderStyle,
    labelVariant = _alloyReactFormField.default.LABEL_VARIANTS.TOP
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_alloyReactFormField.default, {
    style: (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        overflow-wrap: anywhere;\n      "])), _consts.FIELD_WRAPPER_STYLE, style),
    label: label,
    error: errorMessage || undefined,
    required: required,
    labelVariant: labelVariant
  }, loading ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingLeft: "12px",
      height: "36px",
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_InlineLoader.InlineLoader, {
    loaderStyle: loaderStyle
  })) : children);
};
exports.FieldWrapper = FieldWrapper;
//# sourceMappingURL=FieldWrapper.js.map